import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import userActions from '../actions/admin'

export const useAdmin = () => {
  const data = useSelector((state) => {
    return get(state, 'app.adminManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(userActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
